<template>
  <div id="history_page" class="page-wrapper">
    <section class="page-title">
      <div class="left">
        <div class="go-back" @click="goback()">
          <img
            src="@/assets/images/back-arrow-btn.svg"
            class="icon-back"
            alt="back"
          />
        </div>
        {{ lbl.value_design.history.page_title }}
      </div>
    </section>
    <div class="card-wrapper">
      <div v-if="cardDetail" class="card-container">
        <div class="card-design" :style="cardImage(cardDetail.CoverUrl)">
          <div class="number-detail">
            <div class="detail">
              <span>
                {{ displayID(cardDetail.CardId) }}
              </span>
              <a-icon type="info-circle" />
            </div>
            <div class="type">
              <span>
                {{
                  cardDetail.Type == 'digital'
                    ? lbl.value_design.digital_card
                      ? lbl.value_design.digital_card
                      : 'Digital Card'
                    : lbl.value_design.physical_card
                    ? lbl.value_design.physical_card
                    : 'Physical Card'
                }}
              </span>
            </div>
          </div>
          <div class="balance-detail">
            <strong>
              {{ displayBalance(cardDetail.Balance) }}
            </strong>
            <span>
              {{ lbl.value_design.home.currency }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <section class="card-historys">
      <div class="header">
        <strong>
          {{ lbl.value_design.history.table_title }}
        </strong>
        <a-month-picker
          v-model="month"
          allow-clear
          size="small"
          :format="'MMM YYYY'"
          :placeholder="lbl.value_design.history.filter_placeholder"
          :disabled-date="disabledDate"
          class="month-picker"
          @change="onChangeFilter"
        />
      </div>
      <div v-if="historyList.length" class="history-wrapper">
        <div class="month-tab">
          <span>{{ getDataDetail(month, 'month') }}</span>
          <span>{{ getDataDetail(month, 'year') }}</span>
        </div>
        <div
          v-for="(group, i) in historyList"
          :key="`Index_${i}_TransactionId_${group.TransactionId}`"
          class="detail-wrapper"
        >
          <div class="detail">
            <div class="left">
              <img
                src="@/assets/images/valueDesign/map_pin.svg"
                alt="map_pin"
              />
              <span>{{ mapType(group.Type, group.Status) }}</span>
            </div>
            <div class="right">
              {{ numberCommas(group.Amount, group.Type, group.Status) }}
            </div>
          </div>
          <div class="date">
            <span>{{ getDate(group.CreateDate) }}</span>
          </div>
        </div>
      </div>
      <div v-else class="empty">
        <img src="@/assets/images/empty_doc.svg" alt="empty_doc" />
        <strong>{{ lbl.value_design.history.empty_title }}</strong>
        <span>{{ lbl.value_design.history.empty_desc }}</span>
      </div>
    </section>
    <Alert
      :show="alert.show"
      :success="alert.success"
      :title="alert.title"
      :messege="alert.messege"
      @close="alert.show = false"
    />
  </div>
</template>

<script>
import BzbsVD from '@/core/ValueDesign/BzbsValueDesign.js'
import Account from '@/helper/AccountHelper.js'
import Locale from '@/helper/Locale.js'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import Alert from '@/module/ValueDesign/components/AlertModal'
import moment from 'moment'

export default {
  name: 'History',
  components: {
    Alert,
  },
  mixins: [CommonMixin, ResponsiveMixin],
  data() {
    return {
      month: moment(),
      updateTime: null,
      cardDetail: null,
      historyList: [],
      alert: {
        show: false,
        success: false,
        title: null,
        messege: null,
      },
    }
  },
  created() {
    Account.bzbsAnalyticTracking(
      `card_${this.$route.params.Id}_history_page`,
      `value_design`,
      `view_card_${this.$route.params.Id}_history_page`,
      'on view',
    )
    this.init()
  },
  methods: {
    async init() {
      this.handleFooter(false)
      this.handleLanguage(true)
      this.handleLoading(true)
      await this.getCardList().then(() => {
        this.getCardHistory().then(() => {
          this.handleLoading(false)
        })
      })
    },
    async getCardList() {
      return new Promise(resolve => {
        BzbsVD.getCards()
          .then(res => {
            if (res.data.success && res.data.data) {
              this.cardDetail = res.data.data.find(
                card => card.CardId === this.$route.params.Id,
              )
              console.log(this.cardDetail)
            }
            this.updateTime = moment().format('DD/MMM/YYYY - HH:mm')
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    async getCardHistory(filter = null, top = 1000, skip = 0) {
      if (this.cardDetail) {
        var params = {
          cardNo: this.$route.params.Id,
          month: filter
            ? moment(filter).startOf('month').format('YYYY-MM-DD')
            : moment().startOf('month').format('YYYY-MM-DD'),
          top: top,
          skip: skip,
        }
        this.handleLoading(true)

        return new Promise(resolve => {
          BzbsVD.cardHistory(params)
            .then(res => {
              if (res.data.success && res.data.data.length) {
                this.historyList = res.data.data.sort(
                  (a, b) => new Date(b.CreateDate) - new Date(a.CreateDate),
                )

                console.log(this.historyList)
                this.handleLoading(false)
              } else {
                this.historyList = []
                this.handleLoading(false)
              }
              resolve(res.data)
            })
            .catch(error => {
              this.handleLoading(false)
              this.historyList = []
              resolve(error)
            })
        })
      } else {
        this.alert = {
          show: true,
          success: false,
          title: this.lbl.value_design.top_up.not_found_card,
          messege: '',
        }
        setTimeout(() => {
          this.alert.show = false
        }, 2000)
      }
    },
    disabledDate(current) {
      return current > moment().endOf('day')
    },
    onChangeFilter(date) {
      var month = moment(date).format('YYYY-MM-DD')
      this.getCardHistory(month)
    },
    goback() {
      Account.bzbsAnalyticTracking(
        `card_${this.$route.params.Id}_history_page`,
        `value_design`,
        'click_go_back',
        'on click',
      )
      this.$router.push({
        name: 'cardDetail',
        params: { Id: this.$route.params.Id },
      })
    },
    displayBalance(balance) {
      try {
        return new Intl.NumberFormat().format(balance)
      } catch {
        return 0
      }
    },
    displayID(id) {
      return id.slice(0, 6) + '-' + id.slice(6)
    },
    cardImage(img) {
      return img ? { backgroundImage: `url(${img})` } : {}
    },
    getDataDetail(date, type) {
      return moment(date).format(type === 'month' ? 'MMM' : 'YYYY')
    },
    getDate(data) {
      if (data) {
        console.log(moment.unix(data).utc().format('YYYY'))

        var year = null
        if (Locale.getLocale() == 'th') {
          year = parseInt(moment.unix(data).utc().format('YYYY')) + 543
        } else {
          year = moment.unix(data).utc().format('YYYY')
        }
        var date = moment.unix(data).utc().format('DD MMM')
        var time = moment.unix(data).utc().format('HH:mm')
        console.log(year)
        console.log(date)
        console.log(time)
        return `${date} ${year}- ${time}`
      } else {
        return ''
      }
    },
    numberCommas(number, type, status) {
      switch (type) {
        case 'pay':
          if (status == 2) {
            return Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(number)
          } else {
            number = number ? number * -1 : 0
            return Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(number)
          }

        case 'topup':
          if (status == 2) {
            number = number ? number * -1 : 0
            return Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(number)
          } else {
            return Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(number)
          }
        default:
          return Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(number)
      }
    },
    mapType(type, status) {
      switch (type) {
        case 'topup':
          if (status == 2) {
            return this.lbl.value_design.history.refund_topup
          } else {
            return this.lbl.value_design.history.topup
          }
        case 'pay':
          if (status == 2) {
            return this.lbl.value_design.history.refund_pay
          } else {
            return this.lbl.value_design.history.pay
          }
        default:
          return type
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.page-wrapper {
  max-width: 820px;
  margin: auto;
  padding: 0px 20px 50px;
  .page-title {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin: 10px auto;

    .left {
      font-size: 28px;
      font-weight: 500;
      color: #212121;
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      align-items: center;
      .go-back {
        width: 42px;
        height: 42px;
        border-radius: 100px;
        border: 1px solid #eeeeee;
        background-color: #ffffff;
        box-shadow: 0px 4px 10px 0px #0000001a;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon-back {
          width: 16px;
        }
      }
    }
    .right {
      .btn {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
      }
    }
  }
  .card-wrapper {
    width: 100%;
    .card-container {
      place-items: center;

      .card-design {
        box-shadow: 0px 8px 16px 0px #00000026;
        border-radius: 6px;
        width: 100%;
        max-width: 400px;
        height: 230px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        background-size: cover;
        gap: 10px;

        .number-detail {
          display: flex;
          flex-direction: column;
          gap: 4px;
          align-items: flex-end;
          padding: 0px 12px;
          margin-top: 12px;
          .type,
          .detail {
            display: flex;
            padding: 2px 6px;
            align-items: center;
            gap: 4px;
            border-radius: 20px;
            background: rgba(0, 0, 0, 0.5);
            color: #ffffff;
            text-align: center;
            font-size: 10px;
            font-weight: 400;
            letter-spacing: 0.4px;
            width: fit-content;
          }
        }
        .balance-detail {
          border-radius: 0 0 6px 6px;
          background: linear-gradient(
            0deg,
            #ffffff 0%,
            rgba(255, 255, 255, 0.9) 21.25%,
            rgba(255, 255, 255, 0) 100%
          );
          color: #303030;
          display: flex;
          align-items: flex-end;
          padding: 12px;
          gap: 8px;
          color: #303030;
          img {
            width: 32px;
            height: 32px;
          }
          strong {
            font-size: 30px;
            font-weight: 700;
            line-height: 1;
            letter-spacing: 0.25px;
          }
          span {
            font-size: 12px;
            font-weight: 400;
            line-height: 14px;
            letter-spacing: 0.4000000059604645px;
          }
        }
      }
    }
  }
  .card-historys {
    margin-top: 16px;
    font-size: 16px;
    display: flex;
    flex-direction: column;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 8px 0;
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 700;
    }
    .month-tab {
      display: flex;
      font-size: 12px;
      margin: 0 -20px;
      padding: 8px 16px;
      background: #e3e3e3;
      justify-content: space-between;
    }
    .detail-wrapper {
      border-bottom: 1px solid #c9c9c9;
      margin: 0 -20px;
      padding: 8px 16px;
      flex-direction: column;
      display: flex;
      gap: 2px;
      .detail {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        line-height: 21px;
        .left {
          display: flex;
          gap: 4px;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
          }
          font-weight: 400;
          color: #303030;
        }
        .right {
          font-weight: 700;
          color: #4a4a4a;
        }
      }
      .date {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        color: #969696;
      }
    }
    .empty {
      margin: 32px auto;
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: center;
      img {
        width: 120px;
        height: 120px;
        margin-bottom: 4px;
      }
      strong {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-align: center;
        color: #4a4a4a;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        text-align: center;
        color: #636363;
      }
    }
  }
}
</style>
